import { infiniteQueryOptions, keepPreviousData } from '@tanstack/react-query';

import {
  CONTENT_TRACKING_PAGE_LIMIT,
  type ContentTrackingListParams,
  type ContentTrackingPage,
} from '@/marketing/models/contentTracking';
import { contentTrackingAPIClient } from '../contentTrackingAPIClient';
import { CONTENT_TRACKING_KEYS } from './keys';

// Server-side seek pagination: each page carries the cursor of the next one, so filters reset the whole list.
export const CONTENT_TRACKING_QUERIES = {
  list: (campaignId: string, params: ContentTrackingListParams) =>
    infiniteQueryOptions({
      queryKey: CONTENT_TRACKING_KEYS.list(campaignId, params),
      queryFn: ({ pageParam }) =>
        contentTrackingAPIClient.listPage(campaignId, {
          ...params,
          limit: CONTENT_TRACKING_PAGE_LIMIT,
          ...(pageParam ? { cursor: pageParam } : {}),
        }),
      initialPageParam: undefined as string | undefined,
      getNextPageParam: (lastPage: ContentTrackingPage) => lastPage.pageInfo.nextCursor ?? undefined,
      placeholderData: keepPreviousData,
      staleTime: 30 * 1000,
      enabled: campaignId !== '',
    }),
};
